export const routePathMap = {
  config: '/config',
  checkout: '/checkout',
  edit: '/edit',
  add: '/add',
  mix: '/mix',
  downgrade: '/downgrade',
  upgrade: '/upgrade',
  updateSuccess:'/updateSuccess',
  addTrialSuccess: '/addTrialSuccess',
  apmSuccess: '/apmSuccess',
  success: '/success',
}
